import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"
import { Label } from "../atoms/texts/label";

const badgeVariants = cva(
    "inline-flex items-center rounded-full m-1 border justify-center transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 text-center w-6 h-6",
    {
        variants: {
            variant: {
                default:
                    "border-white bg-secondary text-secondary-foreground text-body",
                defaultPrimary:
                    " bg-primary text-secondary font-semibold",
                warning:
                    "border-transparent bg-warning text-warning-foreground ",
                success:
                    "border-transparent bg-success text-success-foreground ",
                information:
                    "border-transparent bg-information  text-white",
                error:
                    "border-transparent bg-error text-error-foreground ",
                outline: "text-foreground",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    }
)

function Badge({
    className,
    variant, text,
    children, message,size,
    ...props
}) {
    return (<div className={cn(badgeVariants({ variant }), className)} {...props} >
        <Label message={message} fontWeight="semibold" size={size || "body"} >{text}</Label>
        {children}
    </div>);
}

export { Badge, badgeVariants }
